import script from "./RFPRespondModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RFPRespondModal.vue?vue&type=script&setup=true&lang=js"

import "./RFPRespondModal.vue?vue&type=style&index=0&id=50e064f6&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e064f6"]])

export default __exports__